import { ApiPromotion, ApiResponse } from '@vend/types'
import { fetchApiJson } from '@vend/utilities'
import { PROMOTIONS_ENDPOINT } from '../promotions.constant'

/**
 * Functions for querying the promotion API
 */

/**
 * Get the promotion by the given id
 *
 * @param {string} promotionId
 *
 * @return {Promise} A promise resolved with the promotion
 */
export function getPromotionById(
  promotionId: string
): Promise<ApiPromotion | null> {
  return fetchApiJson(`${PROMOTIONS_ENDPOINT}/${promotionId}`)
    .then((data: ApiResponse<ApiPromotion>) => data?.data)
    .catch(() => {
      // eslint-disable-next-line no-console
      console.warn('[PromotionsResource] Failed to retrieve promotion')
      return null
    })
}
